const tabs = require('../common/tabs.ts')
const axios = require("axios");
const StartgruppenTemplate = require('./tso_startgruppen.hbs');
const Modal = require('../common/modal');
const StartgruppeForm = require('./tso_startgruppe_form.hbs');
const {FormValidator} = require("../common/form-validator");
const Toast = require('../common/toast');
const {isBackendError} = require("../common/is-backend-error");
const LizenzenTemplate = require('./tso_lizenzen.hbs');
const StartklassenTemplate = require('./tso_startklassen.hbs');
const StartklassenForm = require('./tso_startklasse_form.hbs');

function showProgress(element) {
	element.classList.remove('hidden');
	return Promise.resolve();
}

function hideProgress(element) {
	element.classList.add('hidden');
}

function initStartgruppen(progress, container) {
	showProgress(progress).then(
		() => axios.get('/api/verwaltung/startgruppen')
	).then(
		(result) => result.data.map(item => ({
			...item,
			disableEdit: item.builtin,
			disableDelete: item.builtin || item.used
		}))
	).then(
		(data) => StartgruppenTemplate(data)
	).then(
		(result) => container.innerHTML = result
	).catch(
		e => {
			console.warn('could not load startgroups', {error: e});
			Toast.add('error', 'Startgruppen konnten nicht geladen werden.');
		}
	).finally(
		() => hideProgress(progress)
	);
}

function loadStartgruppe(progress, id) {
	return showProgress(progress).then(
		() => axios.get(`/api/verwaltung/startgruppen/${id}`)
	).then(
		(result) => result.data
	).catch(
		e => {
			console.warn('could not load startgroup', {error: e});
			Toast.add('error', `Startgruppe #${id} konnte nicht geladen werden.`);
		}
	).finally(
		() => hideProgress(progress)
	);
}

function createOrUpdateStartgruppe(progress, model) {
	return showProgress(progress).then(
		() => model.id ? axios.post(`/api/verwaltung/startgruppen/${model.id}`, model) : axios.put('/api/verwaltung/startgruppen', model)
	).then(
		() => {
			let message = model.id ? `Startgruppe #${model.id} aktualisiert.` : 'Startgruppe angelegt';
			Toast.add('success', message);
		}
	).catch(
		e => {
			let message;
			if (axios.isAxiosError(e)) {
				if (isBackendError(e.response.data)) {
					message = e.response.data.message;
				} else {
					message = model.id ? `Startgruppe #${model.id} konnte nicht aktualisiert werden (${e.response.status}).` : `Startgruppe konnte nicht angelegt werden (${e.response.status})`;
				}
			} else {
				message = `Unbekannter Fehler: ${e.message}`;
			}
			Toast.add('error', message);
		}
	).finally(
		() => {
			hideProgress(progress);
		}
	)
}

function deleteStartgruppe(progress, id) {
	return showProgress(progress).then(
		() => axios.delete(`/api/verwaltung/startgruppen/${id}`)
	).then(
		() => Toast.add('success', `Startgruppe #${id} gelöscht.`)
	).catch(
		e => {
			let message;
			if (axios.isAxiosError(e)) {
				if (isBackendError(e.response.data)) {
					message = e.response.data.message;
				} else {
					message = `Startgruppe #${id} konnte nicht gelöscht werden (${e.response.status}).`;
				}
			} else {
				message = `Unbekannter Fehler: ${e.message}`;
			}
			Toast.add('error', message);
		}
	).finally(
		() => {
			hideProgress(progress);
		}
	)
}

function initLicenses(progress, container) {
	showProgress(progress).then(
		() => axios.get('/api/verwaltung/lizenzen')
	).then(
		(response) => LizenzenTemplate(response.data)
	).then(
		(result) => container.innerHTML = result
	).catch(
		e => {
			console.warn('could not load licenses', {error: e});
			Toast.add('error', 'Lizenzen konnten nicht geladen werden.');
		}
	).finally(
		() => hideProgress(progress)
	);
}

// für validierung
let startclasses = [];

function initStartclasses(progress, container) {
	showProgress(progress).then(
		() => axios.get('/api/verwaltung/startklassen')
	).then(
		(result) => result.data.map(item => ({
			...item,
			disableEdit: item.builtin,
			disableDelete: item.builtin || item.used
		}))
	).then(
		(data) => {
			startclasses = data;
			return StartklassenTemplate(data);
		}
	).then(
		(result) => container.innerHTML = result
	).catch(
		e => {
			console.warn('could not load startclasses', {error: e});
			Toast.add('error', 'Startklassen konnten nicht geladen werden.');
		}
	).finally(
		() => hideProgress(progress)
	);
}

function loadStartklasse(progress, id) {
	return showProgress(progress).then(
		() => id ? axios.get(`/api/verwaltung/startklassen/${id}`) : Promise.resolve({data: {name: undefined, enabled: false, license: {id: undefined} }})
	).then(
		(result) => result.data
	).catch(
		e => {
			console.warn('could not load startclass', {error: e});
			Toast.add('error', `Startklasse #${id} konnte nicht geladen werden.`);
		}
	).then(
		(startklasse) => axios.get('/api/verwaltung/lizenzen').then(
			(response) => ({startklasse, lizenzen: response.data.map(l => ({...l, selected: l.id === startklasse.license.id}))})
		)
	).catch(
		e => {
			console.warn('could not load licenses', {error: e});
			Toast.add('error', `Lizenzen konnten nicht geladen werden.`);
		}
	).finally(
		() => hideProgress(progress)
	);
}

function createOrUpdateStartklasse(progress, model) {
	return showProgress(progress).then(
		() => model.id ? axios.post(`/api/verwaltung/startklassen/${model.id}`, model) : axios.put('/api/verwaltung/startklassen', model)
	).then(
		() => {
			let message = model.id ? `Startklasse #${model.id} aktualisiert.` : 'Startklasse angelegt';
			Toast.add('success', message);
		}
	).catch(
		e => {
			let message;
			if (axios.isAxiosError(e)) {
				if (isBackendError(e.response.data)) {
					message = e.response.data.message;
				} else {
					message = model.id ? `Startklasse #${model.id} konnte nicht aktualisiert werden (${e.response.status}).` : `Startklasse konnte nicht angelegt werden (${e.response.status})`;
				}
			} else {
				message = `Unbekannter Fehler: ${e.message}`;
			}
			Toast.add('error', message);
		}
	).finally(
		() => {
			hideProgress(progress);
		}
	)
}

function deleteStartklasse(progress, id) {
	return showProgress(progress).then(
		() => axios.delete(`/api/verwaltung/startklassen/${id}`)
	).then(
		() => Toast.add('success', `Startklasse #${id} gelöscht.`)
	).catch(
		e => {
			let message;
			if (axios.isAxiosError(e)) {
				if (isBackendError(e.response.data)) {
					message = e.response.data.message;
				} else {
					message = `Startklasse #${id} konnte nicht gelöscht werden (${e.response.status}).`;
				}
			} else {
				message = `Unbekannter Fehler: ${e.message}`;
			}
			Toast.add('error', message);
		}
	).finally(
		() => {
			hideProgress(progress);
		}
	)
}

function TSO() {
	const tab_startgruppen = tabs.tab('#tab_startgruppen');
	const tab_startklassen = tabs.tab('#tab_startklassen');
	const tab_lizenzen = tabs.tab('#tab_lizenzen');

	const progressStartgroup = document.querySelector('#progress-startgroup');
	const startgroupFormModal = document.querySelector('#startgroupFormModal');
	const containerStartgroupList = document.querySelector('#container-startgroup-list');

	const progressLicenses = document.querySelector('#progress-licenses');
	const containerLicenseList = document.querySelector('#container-license-list');

	const progressStartclass = document.querySelector('#progress-startclass');
	const startclassFormModal = document.querySelector('#startclassFormModal');
	const containerStartclassList = document.querySelector('#container-startclass-list');

	if (tab_startgruppen) {
		tab_startgruppen.on('activate', function (tab) {
			initStartgruppen(progressStartgroup, containerStartgroupList);
		});
	}
	if (tab_startklassen) {
		tab_startklassen.on('activate', function (tab) {
			initStartclasses(progressStartclass, containerStartclassList);
		});
	}
	if (tab_lizenzen) {
		tab_lizenzen.on('activate', function (tab) {
			initLicenses(progressLicenses, containerLicenseList);
		});
	}

	function startgroupFormValidityChanged(valid) {
		document.querySelectorAll('#startgroupFormModal [data-confirm-modal]').forEach(
			confirm => {
				confirm.disabled = !valid;
			}
		)
	}

	function startclassFormValidityChanged(valid) {
		document.querySelectorAll('#startclassFormModal [data-confirm-modal]').forEach(
			confirm => {
				confirm.disabled = !valid;
			}
		)
	}

	return {
		editStartgruppe: (id, event) => {
			event && event.preventDefault();
			loadStartgruppe(progressStartgroup, id).then(
				(startgruppe) => StartgruppeForm(startgruppe)
			).then(
				(html) => startgroupFormModal.innerHTML = html
			).then(
				() => {
					const validator = new FormValidator('#startgroupFormModal form', startgroupFormValidityChanged);
					Modal.create(startgroupFormModal, {
						onConfirm: () => {
							createOrUpdateStartgruppe(progressStartgroup, {
								...validator.getCurrentFormValue(),
								id
							}).then(
								() => initStartgruppen(progressStartgroup, containerStartgroupList)
							);
						}
					});
				}
			)
		},
		createStartgruppe: (event) => {
			event && event.preventDefault();
			startgroupFormModal.innerHTML = StartgruppeForm({});
			const validator = new FormValidator('#startgroupFormModal form', startgroupFormValidityChanged);
			Modal.create(startgroupFormModal, {
				onConfirm: () => {
					createOrUpdateStartgruppe(progressStartgroup, validator.getCurrentFormValue()).then(
						() => initStartgruppen(progressStartgroup, containerStartgroupList)
					);
				}
			});
		},
		deleteStartgruppe: (id, event) => {
			event && event.preventDefault();
			deleteStartgruppe(progressStartgroup, id).then(
				() => initStartgruppen(progressStartgroup, containerStartgroupList)
			);
		},
		editStartklasse: (id, event) => {
			event && event.preventDefault();
			loadStartklasse(progressStartclass, id).then(
				(model) => StartklassenForm(model)
			).then(
				(html) => startclassFormModal.innerHTML = html
			).then(
				() => {
					const uniqueNamesValidator = {
						type: 'name',
						selector: 'name',
						fn: (input) => {
							if (startclasses.find(s => s.id !== id && (input.value || '').trim().toLowerCase() === s.name.trim().toLowerCase()) !== undefined) {
								input.setCustomValidity('Diese Startklasse existiert bereits.');
							} else {
								input.setCustomValidity('');
							}
						}
					}

					const validator = new FormValidator('#startclassFormModal form', startclassFormValidityChanged, [uniqueNamesValidator]);
					Modal.create(startclassFormModal, {
						onConfirm: () => {
							createOrUpdateStartklasse(progressStartclass, {
								...validator.getCurrentFormValue(),
								id
							}).then(
								() => initStartclasses(progressStartclass, containerStartclassList)
							);
						}
					});
				}
			)
		},
		deleteStartklasse: (id, event) => {
			event && event.preventDefault();
			deleteStartklasse(progressStartclass, id).then(
				() => initStartclasses(progressStartclass, containerStartclassList)
			);
		}
	}
}

module.exports = TSO;
